import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { PaymentMethodStateClass } from './interfaces/paymentMethodStateClass'
import { sortData } from '../../../common/timeLiveFunction'
const initialState: PaymentMethodStateClass = {
    isLoading: false,
    status: 'idle',
    paymentMethodList: [],
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'PaymentMethod',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        paymentMethod: PaymentMethodStateClass;
    },
}
export const getAccountPaymentmethodAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'paymentMethod/getAccountPaymentMethods',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PaymentMethods', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getPaymentMethodsByIdIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paymentMethod/getAPaymentMethodsById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PaymentMethods/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const addPaymentMethodsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paymentMethod/addPaymentMethods',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PaymentMethods/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const updatePaymentMethodsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paymentMethod/updatePaymentMethods',
        async (arg, thunkApi) => {
            const { AccountPaymentMethodId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/PaymentMethods/' + AccountPaymentMethodId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;

        }
    )

export const deletePaymentMethodsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'paymentMethod/deletePaymentMethods',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PaymentMethods/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordPaymentMethodAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordPaymentMethod",
        async(arg,thunkApi) =>{
            console.log('farhan',arg);
            const response = await fetchAPI('api/v2/PaymentMethods/DeleteAllSelectedRecordPaymentMethod/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        }
    )



export const paymentMethodSlice = createSlice({
    name: 'paymentMethod',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.paymentMethodList.findIndex((item) => item.AccountPaymentMethodId == action.payload);
            const newArray = [...state.paymentMethodList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.paymentMethodList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.paymentMethodList.findIndex((item) => item.AccountPaymentMethodId == action.payload);
            const newArray = [...state.paymentMethodList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.paymentMethodList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.paymentMethodList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.paymentMethodList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.paymentMethodList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.paymentMethodList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.paymentMethodList;
            state.paymentMethodList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountPaymentmethodAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountPaymentmethodAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.paymentMethodList = payload.Data;
                state.paymentMethodList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
               
            })
            .addCase(getAccountPaymentmethodAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getPaymentMethodsByIdIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getPaymentMethodsByIdIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;

                state.selectedRecord = payload.Data[0];
            })
            .addCase(getPaymentMethodsByIdIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addPaymentMethodsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addPaymentMethodsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addPaymentMethodsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(updatePaymentMethodsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updatePaymentMethodsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updatePaymentMethodsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deletePaymentMethodsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deletePaymentMethodsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deletePaymentMethodsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordPaymentMethodAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAllSelectedRecordPaymentMethodAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordPaymentMethodAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting
} = paymentMethodSlice.actions
export const PaymentMethodState = (state: RootState) => state.paymentMethod
export default paymentMethodSlice.reducer